export default __webpack_public_path__ + "img/fRMSyWFt.65de81ce.svg";